import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Users, X } from "lucide-react";
import { toast } from "sonner";

export function BulkAuftraggeberBar({ selectedIds, auftraggeber, onDone, onClear }) {
  const [ag, setAg] = useState("");
  const [busy, setBusy] = useState(false);
  if (!selectedIds.length) return null;

  const apply = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/projects-bulk/auftraggeber", {
        project_ids: selectedIds, auftraggeber_id: ag === "none" ? "" : ag,
      });
      const name = auftraggeber.find((a) => a.id === ag)?.name;
      toast.success(ag === "none" ? `Zuordnung bei ${data.matched} Projekt(en) entfernt` : `${data.matched} Projekt(e) „${name}“ zugeordnet`);
      setAg("");
      onDone();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Zuordnen fehlgeschlagen");
    } finally { setBusy(false); }
  };

  return (
    <div className="flex flex-wrap items-center gap-3 px-4 py-3 border-b border-border bg-primary/5" data-testid="bulk-ag-bar">
      <Users className="h-4 w-4 text-primary" />
      <span className="text-sm font-medium" data-testid="bulk-ag-count">{selectedIds.length} ausgewählt</span>
      <Select value={ag} onValueChange={setAg}>
        <SelectTrigger className="h-8 w-60 text-xs" data-testid="bulk-ag-select"><SelectValue placeholder="Auftraggeber wählen …" /></SelectTrigger>
        <SelectContent>
          <SelectItem value="none">— ohne Auftraggeber —</SelectItem>
          {auftraggeber.map((a) => <SelectItem key={a.id} value={a.id} data-testid={`bulk-ag-option-${a.id}`}>{a.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <Button size="sm" className="h-8" disabled={!ag || busy} onClick={apply} data-testid="bulk-ag-apply">
        {busy ? "Speichert …" : "Zuweisen"}
      </Button>
      <Button size="sm" variant="ghost" className="h-8 ml-auto" onClick={onClear} data-testid="bulk-ag-clear">
        <X className="h-4 w-4 mr-1" /> Auswahl aufheben
      </Button>
    </div>
  );
}
